(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('entityMetaInfo', ["path", "$q", "widgetPolling", "metaInfoLogicCore", "fileDao", "$timeout", function (path, $q, widgetPolling, metaInfoLogicCore, fileDao, $timeout) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('profile/common/entity-meta-info').template('entity-meta-info'),
            scope: { entityActions: '=' },
            link: function ($scope, element, attrs) {
                var defaultUpdateTick = 300000;
                $scope.updateTick = defaultUpdateTick;
                $scope.widgetApi = {};
                var id = widgetPolling.scope().id;
                var entityType = widgetPolling.scope().entityType;
                var entityDisplayName = _(entityType.split('_')).last();
                var secTypes = widgetPolling.scope().rawEntityInfo.sec_type_connected;
                $scope.title = 'Info';
                $scope.model = {
                    wrapper: {},
                    pair: { 'class': 'file-meta-data' },
                    uuid: '19125d91-2dc0-4a02-8cfd-' + entityType
                };
                var logic = { beautifyKey: true };
                $scope.filters = { uuid: $scope.model.uuid };
                $scope.$watch('model.wrapper.filters', function () {
                    $scope.filters.filters = $scope.model.wrapper.filters;
                });
                var buttons;
                if (secTypes && secTypes.length) {
                    buttons = [{
                            label: 'Recheck',
                            'class': 'btn btn-blue',
                            onClick: function () {
                                return recheckParams.show('Do you want to recheck this ' + entityDisplayName + '?', entityType, secTypes).then(function (data) {
                                    return fileDao.recheck(entityType, id, data.selectApplications ? data.apps : undefined);
                                }).then(function () {
                                    $rootScope.$broadcast('file-security-stack-reload');
                                });
                            },
                            advanced: true
                        }];
                }
                var coreOptions = {
                    autoWidget: true,
                    ordering: 'widgetViewOrder',
                    moduleLabels: {
                        module: widgetPolling.scope().module,
                        entity: entityType
                    },
                    retrieve: function () {
                        return fileDao.entityInfo(entityType, id).after(function (response) {
                        });
                    },
                    buttons: buttons
                };
                var clearLogic = _.noop;
                $scope.loadData = function () {
                    clearLogic();
                    if ($scope.restoreUpdateTickAfter && $scope.restoreUpdateTickAfter.isBefore(moment())) {
                        $scope.updateTick = defaultUpdateTick;
                        $scope.restoreUpdateTickAfter = null;
                    }
                    clearLogic = metaInfoLogicCore($scope, logic, coreOptions);
                    return $q.when();
                };
                if ($scope.entityActions) {
                    $scope.$watch('model.entityData', function (data) {
                        if (data) {
                            if (!$scope.actionsWidget) {
                                $scope.actionsWidget = {
                                    logic: {
                                        name: 'remediationActionsLogic',
                                        updateTick: null,
                                        entityType: entityType
                                    },
                                    actions: $scope.entityActions
                                };
                            }
                            $scope.actionsWidget.entityData = data;
                        }
                    });
                    var onActionUnsubscribe = widgetPolling.on('remediationActionPerformed', function () {
                        $scope.updateTick = 2000;
                        $scope.restoreUpdateTickAfter = moment().add(1, 'minutes');
                        $timeout(function () {
                            $scope.widgetApi.reload();
                        });
                    });
                    $scope.$on('$destroy', function () {
                        onActionUnsubscribe();
                    });
                }
            }
        };
    }]);
}());